
































import { Component, Vue } from 'vue-property-decorator'
import DevToolsModule from '@/common/store/DevToolsModule'
import { systemLogTransformer, SystemLogType } from './models/SystemLog'

@Component({
  filters: {
    systemLogType(systemLogType: SystemLogType) {
      return systemLogTransformer(systemLogType)
    }
  }
})
export default class extends Vue {
  get errors() {
    return DevToolsModule.systemLogs
  }
  copy(str: string) {
    const input = document.createElement('input') // 直接构建input
    input.value = str // 设置内容
    document.body.appendChild(input) // 添加临时实例
    input.select() // 选择实例内容
    document.execCommand('Copy') // 执行复制
    document.body.removeChild(input) // 删除临时实例
    this.$message.success('复制成功')
  }
}
